import { render, staticRenderFns } from "./App.vue?vue&type=template&id=705d0b2b&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/xampp/htdocs/riiqo-website-2020/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VAppBar } from 'vuetify/lib'
import { VAppBarNavIcon } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VApp,VAppBar,VAppBarNavIcon,VCol,VContainer,VFooter,VRow})
